import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import About from "@/pages/About";
import WorkWithMe from "@/pages/WorkWithMe";
import Contact from "@/pages/Contact";
import Calculator from "@/pages/Calculator";
import Intake from "@/pages/Intake";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ClaimPrintView from "@/pages/ClaimPrintView";
import Dashboard from "@/pages/Dashboard";
import VeteranDetail from "@/pages/VeteranDetail";
import VeteransTable from "@/pages/VeteransTable";
import ArticleManager from "@/pages/ArticleManager";
import Portal from "@/pages/Portal";
import RatesManager from "@/pages/RatesManager";
import AdminClaims from "@/pages/AdminClaims";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import { LearnHub, LearnArticle } from "@/pages/Learn";

function Router() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <div className="flex flex-col min-h-screen bg-background">
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/about" element={<About />} />
          <Route path="/calculator" element={<Calculator />} />
          <Route path="/learn" element={<LearnHub />} />
          <Route path="/learn/:slug" element={<LearnArticle />} />
          {/* Legacy blog paths */}
          <Route path="/blog" element={<LearnHub />} />
          <Route path="/blog/:slug" element={<LearnArticle />} />
          <Route path="/work-with-me" element={<WorkWithMe />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/intake" element={<Intake />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/admin" element={<Dashboard />} />
          <Route path="/admin/veterans" element={<VeteransTable />} />
          <Route path="/admin/articles" element={<ArticleManager />} />
          <Route path="/admin/rates" element={<RatesManager />} />
          <Route path="/admin/claims" element={<AdminClaims />} />
          <Route path="/admin/veteran/:id" element={<VeteranDetail />} />
          <Route path="/portal" element={<Portal />} />
          <Route path="/portal/claim/:cid/print" element={<ClaimPrintView />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Router />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
